<div class="approvals-container">
  @if (routeSegmentId === 'approvals') {
    <div class="row no-gutter approval-header">
      <div class="col layout-header">
        <div class="vendor-txt">
          @if (showBack) {
            <span class="back-icon">
              <i class="pi pi-angle-left" aria-hidden="true" (click)="dashboard()"></i>
            </span>
          }
          <span class="approval-txt">Approvals</span>
        </div>
      </div>
      @if (role === 'superadmin' || role === 'SuperAdminRead') {
        <div class="vendor-filter">
          <select class="form-select" aria-label="Default select example" (change)="vendorSelect($event.target.value)">
            <option value="all" selected>All Vendors</option>
            @for (i of vendorCollections; track i) {
              <option>{{ i }}</option>
            }
          </select>
        </div>
      }
    </div>
  }

  <div class="search">
    <form [formGroup]="searchForm" class="searchClass">
      <div class="searchText">
        <img src="../../../../assets/images/search-icon.png" class="searchImg" />
        <input class="form-control" formControlName="searchText" type="text" name="search" autocomplete="off"
          placeholder="Search Associates" style="font-family: Arial, FontAwesome" maxlength="60" autocomplete="off"
          (keyup)="onSearch($event)" />
        </div>
      </form>
    </div>

    <div class="card">
      <!-- <p-toast></p-toast> -->

    <p-table #dt [value]="
        allApprovalList
          | paginate
            : {
                itemsPerPage: pageData.pageSize,
                currentPage: pageData.pageNumber,
                totalItems: pageData.totalItems
              }
      " [rows]="allApprovalList.length" [paginator]="false"
      [globalFilterFields]="['first_name', 'contact', 'external_id']" [tableStyle]="{ 'min-width': 'auto' }"
      [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {{
        allApprovalList.length
      }} entries" [showCurrentPageReport]="true">
      <ng-template pTemplate="caption">
        <!-- <div class="searchField">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($event.target.value, 'contains')"
            placeholder="Search Associates"
            />
          </span>
        </div> -->
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <!-- <th style="width: 4rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->
        <th>S.NO.</th>
        <th pSortableColumn="firstname">
          FIRST NAME
          <p-sortIcon field="firstname"></p-sortIcon>
        </th>
        <th pSortableColumn="lastname">
          LAST NAME
          <p-sortIcon field="lastname"></p-sortIcon>
        </th>
        <th pSortableColumn="mobile">
          MOBILE NUMBER
          <p-sortIcon field="mobile"></p-sortIcon>
        </th>
        <th pSortableColumn="organizationname">
          VENDOR
          <p-sortIcon field="organizationname"></p-sortIcon>
        </th>
        <th pSortableColumn="role">
          USER ROLE
          <p-sortIcon field="role"></p-sortIcon>
        </th>
        <th>ACTION</th>
      </tr>
    </ng-template>

    <ng-container>
      <ng-template pTemplate="body" let-user let-rowIndex="rowIndex">
        <tr>
          <!-- <td>
          <p-tableCheckbox [value]="product"></p-tableCheckbox>
        </td> -->

        <td class="text-center sno">
          {{
          pageData.pageSize *
          (pageData.pageNumber > 0 ? pageData.pageNumber - 1 : 0) +
          rowIndex +
          1
          }}
        </td>
        <td>
          <p class="fname">{{ user.firstname }}</p>
        </td>
        <td>
          <p class="lname">{{ user.lastname }}</p>
        </td>
        <td>
          <p class="mobileno">
            {{ user.mobile ? "+91 " + user.mobile : "-" }}
          </p>
        </td>
        <td>
          <p class="vendorname">
            {{ user.vendorDetails.organizationname }}
          </p>
        </td>
        <td>
          <p class="rolename">{{ user.role }}</p>
        </td>
        @if ((permissions.delete || permissions.create) && superadmin) {
          <td class="action text-center">
            @if (permissions.create) {
              <button type="button" class="action-btns"
                (click)="confirmApproveOrReject(true, user)">
                <i class="pi pi-check" aria-hidden="true"></i>
              </button>
            }
            @if (permissions.delete) {
              <button type="button" class="action-btns reject"
                (click)="confirmApproveOrReject(false, user)">
                <i class="pi pi-times" aria-hidden="true"></i>
                <!-- <img
                class="trash"
                src="../../../../assets/images/trash-can.svg"
                /> -->
              </button>
            }
          </td>
        }
        @if (Vendoradmin && user.approved) {
          <td class="action">
            Approved
          </td>
        }
        @if (Vendoradmin && user.rejected) {
          <td class="action red-flag">
            Rejected
          </td>
        }
        @if (Vendoradmin && !user.rejected && !user.approved) {
          <td class="action orange-flag">
            Pending
          </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      @if (!allApprovalList.length) {
        <tr>
          <td colspan="7" style="text-align: center; border: none">
            <div style="margin-top: 20px; font-size: 13px">
              No Users available
            </div>
          </td>
        </tr>
      }
    </ng-template>
  </ng-container>
</p-table>

@if (allApprovalList.length > 0) {
  <div class="pagination-section my-pagination pageclass">
    <pagination-controls (pageChange)="setCurrentPageNumber($event)" [nextLabel]="pageControl.nextLabel"
      [previousLabel]="pageControl.previousLabel" [responsive]="pageControl.responsive"
    [autoHide]="pageControl.autoHide"></pagination-controls>
  </div>
}
</div>
</div>